import * as FiIcons from 'react-icons/fi';

export const services = [
  {
    key: 'electrical',
    title: 'Electrical',
    icon: FiIcons.FiZap,
    color: '#f7b916',
    description: 'Safe and reliable electrical maintenance and repairs.',
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=900&q=85',
    items: [
      'Electrical repairs',
      'Light installation',
      'Switch & socket replacement',
      'Basic electrical maintenance',
      'Fault finding',
      'Other electrical services'
    ]
  },
  {
    key: 'plumbing',
    title: 'Plumbing',
    icon: FiIcons.FiDroplet,
    color: '#0874c9',
    description: 'Fix leaks, fittings, blockages and everyday plumbing issues.',
    image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=900&q=85',
    items: [
      'Leak repairs',
      'Faucet installation',
      'Sink repairs',
      'Toilet repairs',
      'Pipe & fitting maintenance',
      'General plumbing issues'
    ]
  },
  {
    key: 'painting',
    title: 'Painting',
    icon: FiIcons.FiEdit3,
    color: '#1e9b5b',
    description: 'Professional painting and home touch-up services for your home.',
    image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=900&q=85',
    items: [
      'Interior painting',
      'Touch-ups',
      'Wall painting',
      'Repainting',
      'Small painting jobs',
      'Maintenance painting'
    ]
  },
  {
    key: 'handyman',
    title: 'Handyman',
    icon: FiIcons.FiTool,
    color: '#ed5b36',
    description: 'General repairs, installations, maintenance and odd jobs.',
    image: 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?auto=format&fit=crop&w=900&q=85',
    items: [
      'Furniture assembly',
      'Fixture installation',
      'Shelving installation',
      'Door & hardware repairs',
      'General home maintenance'
    ]
  }
];

export const faqs = [
  ['What services does OtterWorks provide?', 'We provide electrical, plumbing, painting, handyman and general home maintenance services.'],
  ['How do I request a service?', 'Contact us directly by phone, WhatsApp or email to request a service.'],
  ['Do you provide quotes before starting work?', 'Yes. We will discuss the work and provide clear pricing before approved work begins.'],
  ['Can I request a specific date and time?', 'Yes. Contact our team with your preferred date and time and we will confirm availability.'],
  ['Do you provide emergency services?', 'Contact us for urgent issues and we will help determine the safest next step.'],
  ['Do I need to provide materials?', 'Usually not. We can discuss materials and parts with you before the appointment.'],
  ['What areas do you service?', 'Contact our team with your location and we will quickly confirm service availability.'],
  ['How can I contact OtterWorks?', 'Call or WhatsApp +65 9005 5900, or email info@otterworks.hostfig.com.'],
  ['Can I send photos of the problem?', 'Absolutely. Photos help us understand the issue and prepare for your visit.'],
  ['Do you provide ongoing home maintenance?', 'Yes. We can discuss regular maintenance suited to your property and priorities.']
];

export const gallery = [
  ['Light Installation', 'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=900&q=85'],
  ['Plumbing Repair', 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=900&q=85'],
  ['Wall Painting', 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=900&q=85'],
  ['Furniture Assembly', 'https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&w=900&q=85'],
  ['Fixture Installation', 'https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=900&q=85'],
  ['General Repairs', 'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?auto=format&fit=crop&w=900&q=85']
];

export const testimonials = [
  ['OtterWorks fixed our wiring issue quickly and professionally. Great service!', 'Sarah M.', 'Electrical Service'],
  ['The plumber was on time and solved our leak problem fast.', 'James T.', 'Plumbing Service'],
  ['Excellent painting work and very friendly team. Highly recommended.', 'Priya K.', 'Painting Service']
];